import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import '../../App.css';

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="hero-grid"></div>
        <div className="hero-orb"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Cloud Solutions <span className="highlight">Engineered</span> for Growth
            </h1>
            <p className="hero-subtitle">
              Aamb delivers enterprise-grade software solutions with startup agility
            </p>
            <div className="hero-cta">
              <Link to="/about" className="primary-button">Get Started <FiArrowRight /></Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="code-block">
              <div className="code-line"><span className="code-var">const</span> solution = <span className="code-str">"scalable"</span></div>
              <div className="code-line"><span className="code-var">const</span> architecture = <span className="code-str">"aws-native"</span></div>
              <div className="code-line"><span className="code-var">const</span> delivery = <span className="code-str">"rapid"</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
